import { c as _c } from "react/compiler-runtime";
import { FaroTable } from "@components/common/faro-table/faro-table";
import { FaroTableColumnVisibilityMenu } from "@components/common/faro-table/faro-table-column-visibility-menu";
import { GROUPS_SORT_BY_MAP } from "@components/groups/groups-constants";
import { GROUPS_TABLE_COLUMN_LABELS } from "@components/table/groups/groups-table-constants";
import { getSortByFromGridSortModel } from "@components/table/groups/groups-table-utils";
import { useGroupsColumns } from "@components/table/groups/use-groups-table-columns";
import { useAppNavigation } from "@hooks/navigation/use-app-navigation";
import { useHandleColumnOrderChange } from "@hooks/use-handle-column-order-change";
import { useAppDispatch } from "@store/store-helper";
import { setTableType } from "@store/table/table-slice";
import { TableType } from "@utils/track-event/track-event-list";
import { useCallback, useEffect, useMemo } from "react";
/** Listing all the groups of a company */
export function GroupsTable(t0) {
  const $ = _c(21);
  const {
    companyId,
    groups,
    isLoading,
    bulkActionButtons,
    sortBy,
    setSortBy
  } = t0;
  const {
    navigateToGroupDetails
  } = useAppNavigation();
  const dispatch = useAppDispatch();
  const handleColumnOrderChange = useHandleColumnOrderChange(TableType.groups);
  const columns = useGroupsColumns();
  const t1 = GROUPS_SORT_BY_MAP[sortBy];
  let t2;
  if ($[0] !== t1) {
    t2 = [t1];
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const sortModel = t2;
  let t3;
  if ($[2] !== setSortBy) {
    t3 = newModel => {
      const newSortBy = getSortByFromGridSortModel(newModel);
      if (!setSortBy) {
        return;
      }
      setSortBy(newSortBy);
    };
    $[2] = setSortBy;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const handleSortModelChange = t3;
  let t4;
  let t5;
  if ($[4] !== dispatch) {
    t4 = () => {
      dispatch(setTableType(TableType.groups));
    };
    t5 = [dispatch];
    $[4] = dispatch;
    $[5] = t4;
    $[6] = t5;
  } else {
    t4 = $[5];
    t5 = $[6];
  }
  useEffect(t4, t5);
  let t6;
  if ($[7] !== companyId || $[8] !== navigateToGroupDetails) {
    t6 = group => navigateToGroupDetails({
      companyId,
      groupId: group.id
    });
    $[7] = companyId;
    $[8] = navigateToGroupDetails;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <FaroTableColumnVisibilityMenu labelsMap={GROUPS_TABLE_COLUMN_LABELS} disabledColumns={["name"]} tableType={TableType.groups} />;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      "& .MuiDataGrid-row": {
        cursor: "pointer"
      },
      "& .MuiDataGrid-columnHeader:hover .drag-handle": {
        display: "flex"
      },
      "& .MuiDataGrid-columnHeaderTitleContainerContent": {
        width: "100%"
      }
    };
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== bulkActionButtons || $[13] !== columns || $[14] !== groups || $[15] !== handleColumnOrderChange || $[16] !== handleSortModelChange || $[17] !== isLoading || $[18] !== sortModel || $[19] !== t6) {
    t9 = <FaroTable entities={groups} uniqueIdKey="id" isLoading={isLoading} columns={columns} onRowClick={t6} bulkActionButtons={bulkActionButtons} rowHeight={70} tableType={TableType.groups} onSortModelChange={handleSortModelChange} sortTrackingSubject="Group" sortModel={sortModel} filterMenuTrigger={t7} onColumnOrderChange={handleColumnOrderChange} sx={t8} />;
    $[12] = bulkActionButtons;
    $[13] = columns;
    $[14] = groups;
    $[15] = handleColumnOrderChange;
    $[16] = handleSortModelChange;
    $[17] = isLoading;
    $[18] = sortModel;
    $[19] = t6;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  return t9;
}